export default [

     {
          path: '/export-template',
          name: 'ExportTemplate',
          component: () => import("@/views/Page/ExportTemplate/ExportTemplate.vue"),
           meta: {
               title: 'ExportTemplate',
          },
     }
];